module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('table', {
    class: ['table', _vm.striped && 'table-striped', _vm.bordered && 'table-bordered', _vm.hover && 'table-hover', _vm.condensed && 'table-condensed']
  }, [(_vm.columnProps.length > 0) ? _c('thead', [_c('tr', _vm._l((_vm.columnProps), function(item, idx) {
    return _c('td', [_vm._v("\n\t\t\t\t" + _vm._s(item.label) + "\n\t\t\t")])
  }))]) : _vm._e(), _vm._v(" "), (_vm.columnProps.length > 0) ? _c('tbody', _vm._l((_vm.data), function(data) {
    return _c('tr', _vm._l((_vm.columnProps), function(item, idx) {
      return _c('td', [_vm._v(_vm._s(_vm._f("inline")(item, data)))])
    }))
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-65e7e2f0!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/css/table.vue
// module id = 320
// module chunks = 2